import React, { memo } from 'react';
import './Button.css';

const Button = memo(({ 
  children, 
  variant = 'primary', 
  size = 'default',
  disabled = false,
  loading = false,
  icon,
  block = false,
  danger = false,
  className = '',
  ariaLabel,
  ariaDescribedBy,
  type = 'button',
  onClick,
  ...props 
}) => {
  const classes = [
    'styled-button',
    `styled-button--${variant}`,
    `styled-button--${size}`,
    disabled && 'styled-button--disabled',
    loading && 'styled-button--loading',
    block && 'styled-button--block',
    danger && 'styled-button--danger',
    icon && !children && 'styled-button--icon-only',
    className
  ].filter(Boolean).join(' ');

  const handleClick = (e) => {
    if (disabled || loading) {
      e.preventDefault();
      return;
    }
    onClick?.(e);
  };

  return (
    <button 
      className={classes} 
      type={type}
      disabled={disabled || loading}
      aria-label={ariaLabel}
      aria-describedby={ariaDescribedBy}
      aria-busy={loading}
      onClick={handleClick}
      {...props}
    >
      {loading && (
        <span className="styled-button__spinner" role="status" aria-hidden="true">
          <span className="styled-button__spinner-dot"></span>
          <span className="styled-button__spinner-dot"></span>
          <span className="styled-button__spinner-dot"></span>
        </span>
      )}
      {icon && <span className="styled-button__icon" aria-hidden="true">{icon}</span>}
      {children && <span className="styled-button__text">{children}</span>}
    </button>
  );
});

Button.displayName = 'Button';

export default Button;